/**
 * KYC contracts. DigiLocker only — the backend's `verificationStrategy`
 * hardcodes `DIGILOCKER` for Aadhaar and OTP is deprecated, so the OTP and
 * PAN flows in the Android app are deliberately not ported.
 */

/** Aadhaar. Android's `AADHAAR_DOC_TYPE`, used when the landing call omits it. */
export const AADHAAR_DOC_TYPE = 5;

/** Android treats anything that is not an explicit "OTP" as DigiLocker. */
export const OTP_STRATEGY = 'OTP';

export interface IKycDocIdData {
  documentType?: number;
  verificationStrategy?: string;
}

/**
 * `getKycDocsV4`. Only the nested `docIdData` is read — for `documentType` and
 * `verificationStrategy`; the rest of the landing payload drives Android's
 * multi-document UI, which this does not reproduce.
 */
export interface IKycLandingData {
  aadharData?: {
    docNumberFlow?: {
      docIdData?: IKycDocIdData;
    };
  };
}

export interface IKycInitDigiLockerRequest {
  docType: number;
}

/**
 * `initializeDigiLockerKyc`.
 *
 * `url` is the piece the Android app ignores — it hands `token` to the native
 * SurePass SDK instead. On web the URL is the whole integration: send the
 * browser there, then complete with `clientId`.
 */
export interface IKycInitDigiLockerData {
  url?: string;
  token?: string;
  clientId?: string;
  expirySeconds?: number;
}

export interface IKycCompleteDigiLockerRequest {
  clientId: string;
  docType: number;
}

export type TKycDigiLockerStatus = 'APPROVED' | 'REJECTED';

/**
 * `completeDigiLockerKyc`. One object for both outcomes — branch on `status`.
 * `reason` is `PROVIDER_FAILED | USER_CANCELLED | SESSION_EXPIRED`.
 */
export interface IKycCompleteDigiLockerData {
  status?: TKycDigiLockerStatus;
  kycData?: Record<string, unknown>;
  rewardPublished?: boolean;
  reason?: string;
  retryAllowed?: boolean;
  retriesLeft?: number;
  /**
   * Server-authored copy. Always set on APPROVED (names the verified document);
   * on REJECTED only when the backend has something more specific than `reason`.
   */
  message?: string;
}
